'use strict';

import {
    addSelectedCompanyHandler,
    fnToastrFormError,
    getSelectedCompanyForUser,
    printResponse,
    toggleDisplaySelectClient
} from "../jquery-functions-library";
import {element_exists} from "../functions";

export function fnRogerAI() {

    if (!element_exists('#roger_iframe')) return;

    let $formRogerLogin = $('#form_roger_login');
    let $containerFormRogerLogin = $('.container-form_roger_login');
    let $formRogerIFrame = $('#roger_iframe');
    let $containerRogerIFrame = $('.container-roger_iframe');
    let $alertMissingTeam = $('.alert-missing-team');
    let $alertMissingTeamText = $('.alert-missing-team-text');
    let $rogerLoader = $('.roger_loader');
    let $rogerLoginText = $('.roger_login_text');
    let $alertLoadingTeams = $('.alert-roger-loading-teams');

    loadInitial();

    function selectedCompanyHandle() {
        $containerFormRogerLogin.addClass('hidden');
        $containerRogerIFrame.addClass('hidden');
        $alertMissingTeam.addClass('hidden');
        loadInitial();
    }

    addSelectedCompanyHandler(selectedCompanyHandle);

    function loadInitial() {
        let companyId = getSelectedCompanyForUser();
        let isDefaultSelected = companyId === 'default';

        toggleDisplaySelectClient(isDefaultSelected);

        if (isDefaultSelected) return;

        let data = {
            company_id: companyId ? companyId : null,
        };

        $.ajax({
            type: 'POST',
            url: $formRogerIFrame.data('url'),
            data: data,
            success: function (response) {
                loadPage(response);
            },
            error: fnToastrFormError
        });
    }

    function loadPage(response) {
        $rogerLoader.addClass('hidden');
        $rogerLoginText.removeClass('hidden');

        if (response.rogerSrc !== null) {
            $containerFormRogerLogin.addClass('hidden');
            $containerRogerIFrame.removeClass('hidden');

        } else {
            $containerFormRogerLogin.removeClass('hidden');
            $containerRogerIFrame.addClass('hidden');
        }
        $formRogerIFrame.attr('src', response.rogerSrc);


        if (response.teamMissingTxt !== null) {
            $alertMissingTeam.removeClass('hidden');
            $alertMissingTeamText.html(response.teamMissingTxt)
        } else {
            $alertMissingTeam.addClass('hidden');
        }
    }

    $('.btn-close-alert-missing-team').off('click').on('click', function (e) {
        e.preventDefault();
        $alertMissingTeam.addClass('hidden');
    })

    $formRogerLogin.off('submit').on('submit', function (e) {
        e.preventDefault();
        let companyId = getSelectedCompanyForUser();
        let isDefaultSelected = companyId === 'default';

        if (isDefaultSelected) return;

        let showLoadingMessageTimer = setTimeout(function () {
            $alertLoadingTeams.removeClass('hidden');
        }, 2000);

        $rogerLoader.removeClass('hidden');
        $rogerLoginText.addClass('hidden');

        let data = {
            username: $(this).find('#roger_username').val(),
            password: $(this).find('#roger_password').val(),
            company_id: companyId ? companyId : null,
        };

        $.ajax({
            type: 'POST',
            url: this.action,
            data: data,
            success: function (response) {
                printResponse(response);
                loadPage(response);

                clearTimeout(showLoadingMessageTimer);
                $alertLoadingTeams.addClass('hidden');
            },
            error: function (error) {
                $rogerLoader.addClass('hidden');
                $rogerLoginText.removeClass('hidden');

                clearTimeout(showLoadingMessageTimer);
                $alertLoadingTeams.addClass('hidden');

                fnToastrFormError(error);
            }
        });
    });
}